export default {
    label_task:{
        en:"Districts",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New District",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit District",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of District",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}